
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import './assets/fonts/bootstrap-icons-subset.css'; // Local subset (~55 glyphs used) instead of the full 2000+ icon font; regenerate via scripts/_extract-codepoints.js + _subset-icons.js + _build-icon-css.js if new bi-* classes are added

// SECURITY NOTE: This implementation appears secure against unconditional debug-tooling exposure - there is no verbose
// console logging of app state, no manual React DevTools hook manipulation, and no dev-only code left unguarded here;
// React.StrictMode is safe to ship (its extra checks/double-invocations are dev-build only and are stripped in production
// builds by React itself). React DevTools' browser-extension hook (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) is standard and
// outside this file's control.
// ⚡ SEVERITY: ⚪ INFO - 0%
// Auto-recover from a stale-cached JS bundle trying to load a lazy route chunk that no longer
// exists after a deploy - webpack deletes old-hash chunk files on every build, so a browser tab
// left open across a deploy gets a 404/MIME-type error trying to fetch its old chunk reference.
// Reload once instead of leaving the user on a broken page; sessionStorage guards against looping
// if a chunk is genuinely missing/broken rather than just stale.
const isChunkLoadError = (message) =>
  typeof message === 'string' && (message.includes('ChunkLoadError') || message.includes('Loading chunk') || message.includes('Loading CSS chunk'));

const recoverFromChunkError = (message) => {
  if (isChunkLoadError(message) && !sessionStorage.getItem('chunk-reload')) {
    sessionStorage.setItem('chunk-reload', '1');
    window.location.reload();
  }
};
window.addEventListener('error', (e) => recoverFromChunkError(e.message));
window.addEventListener('unhandledrejection', (e) => recoverFromChunkError(e.reason?.message));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
// Reaching this point means the initial load succeeded - clear the guard so a future chunk error
// (e.g. from the next deploy, while this tab is still open) can still trigger one fresh reload.
sessionStorage.removeItem('chunk-reload');

// SECURITY NOTE: reportWebVitals() is called with no callback argument, and reportWebVitals.js's exported function is a
// no-op unless passed a Function, so today this line sends no data anywhere and poses no exposure. If a callback is added
// later (e.g. to report metrics to an analytics endpoint), it should be reviewed for what data it sends and gated by
// environment/consent at that time - flagging so this stays a no-op is a deliberate choice, not an oversight to "fix" silently.
// ⚡ SEVERITY: ⚪ INFO - 0%
reportWebVitals();
